export default {
  APP_FILTER_CHANGE: Symbol('APP_FILTER_CHANGE'),
  APP_TOGGLE_PRODUCT_DETAILS: Symbol('APP_TOGGLE_PRODUCT_DETAILS'),
  APP_TOGGLE_PRODUCT_SECTION: Symbol('APP_TOGGLE_PRODUCT_SECTION'),
};
